<div class="card cardsmall">
    <div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
        <div class="col-12 pl-2">
                <p-tabView>
                    
                    <p-tabPanel header="{{tabsFields[0].title}}">
                        <form [formGroup]="form">
                            <div class="formgrid">       
                                <formly-form [model]="model" 
                                [fields]="tabsFields[0].fields" 
                                [options]="options" 
                                [form]="form"></formly-form>                     
                            </div>
                        </form>
                    </p-tabPanel>
                    <p-tabPanel header="Configurazione permessi" *ngIf="action!='new'">
                        <div class="grid">
                            <div class="col-12">
                                <p-table #maintable [value]="model.resultspermits" 
                                dataKey="id" 
                                [rows]="10" 
                                [loading]="loading" 
                                [rowHover]="true" 
                                styleClass="p-datatable-gridlines" 
                                [paginator]="false" 
                                responsiveLayout="scroll">
                                
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="min-width: 12rem">
                                                Modulo
                                        </th>
                                        <th style="min-width: 8rem;text-align:center;">
                                                Consenti Accesso
                                        </th>
                                        <th style="min-width: 8rem;text-align:center;">
                                                Consenti modifica
                                        </th>
                                        <th style="min-width: 8rem;text-align:center;">
                                                Consenti cancellazione
                                        </th>
                                        <th style="min-width: 8rem;text-align:center;">
                                                Consenti esportazione
                                        </th>

                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-perm>
                                    <tr>
                                        <td>
                                            {{perm.module}}
                                        </td>
                                        <td pEditableColumn style="text-align:center;">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-checkbox [(ngModel)]="perm.access" [binary]="false" inputId="tricheckbox" />
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                   {{ perm.access === null ? 'Non impostato' : ( perm.access === true ? 'Abilitato':'Non abilitato') }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td pEditableColumn style="text-align:center;">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-checkbox [(ngModel)]="perm.edit"  [binary]="false" inputId="tricheckbox" />
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                   {{ perm.edit === null ? 'Non impostato' : ( perm.edit === true ? 'Abilitato':'Non abilitato') }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td pEditableColumn style="text-align:center;">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-checkbox [(ngModel)]="perm.delete"  [binary]="false" inputId="tricheckbox" />
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                   {{ perm.delete === null ? 'Non impostato' : ( perm.delete === true ? 'Abilitato':'Non abilitato') }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td pEditableColumn style="text-align:center;">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-checkbox [(ngModel)]="perm.export"  [binary]="false" inputId="tricheckbox" />
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                   {{ perm.export === null ? 'Non impostato' : ( perm.export === true ? 'Abilitato':'Non abilitato') }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="loadingbody">
                                    <tr>
                                        <td colspan="8">Caricamento in corso ...</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>

        </div>
    </div>
</div>
<div class="grid">
    <div class="col-12">
        <div class="flex-1 w-full lg:w-3 xl:w-4 flex flex-column row-gap-3">
            <div class="flex flex-column sm:flex-row gap-3 py-2">
                <button
                pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="annulla()"
                label="Annulla"></button>
                <button  *ngIf="action!='delete'"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="save()"
                [disabled]="!form.valid"
                label="Salva" icon="pi pi-fw pi-check"></button>
                <button  *ngIf="action=='delete'"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="delete()"
                label="Cancella" icon="pi pi-fw pi-trash"></button>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>
